import React from 'react';
import { Box, Paper, Typography, Grid, LinearProgress } from '@mui/material';
import { Pie } from 'react-chartjs-2';
import { t } from '../../../utils/textUtils';
import { prepareStatusChartData } from '../utils/chartHelpers';
import { statusColors } from '../utils/formatters';

const ProjectStatusDistribution = ({ 
  projects, 
  dashboardOverviewData, 
  statusCounts 
}) => {
  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          borderColor: 'divider',
          minHeight: '450px',
          bgcolor: '#ffffff'
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 1
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a' }}>
            {t('DISTRIBUSI STATUS PROYEK')}
          </Typography>
        </Box>
        
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 5 }}>
            <Box sx={{ height: 240 }}>
              {projects.length > 0 ? (
                <Pie 
                  data={prepareStatusChartData(projects, statusColors)} 
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        position: 'right',
                        labels: {
                          boxWidth: 15,
                          usePointStyle: true,
                          pointStyle: 'circle'
                        }
                      },
                      tooltip: {
                        backgroundColor: 'rgba(26, 59, 110, 0.8)',
                        titleFont: { weight: 'bold' },
                        padding: 10,
                        cornerRadius: 4
                      }
                    }
                  }}
                />
              ) : (
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  height: '100%'
                }}>
                  <Typography variant="body2" color="text.secondary">
                    {t('TIDAK ADA DATA PROYEK')}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
          
          <Grid size={{ xs: 12, md: 7 }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
              {t('PEMBAGIAN STATUS')}
            </Typography>
            
            <Box sx={{ mt: 2 }}>
              {(() => {
                const statusData = Object.keys(dashboardOverviewData.statusDistribution).length > 0 ? 
                  dashboardOverviewData.statusDistribution : statusCounts;
                const projectsData = dashboardOverviewData.projects.length > 0 ? 
                  dashboardOverviewData.projects : projects;
                
                return Object.keys(statusData).length > 0 ? (
                  Object.keys(statusData).map((status, index) => {
                    const formattedStatus = status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
                    const statusColor = statusColors[status] || '#757575';
                    const percentage = Math.round((statusData[status] / projectsData.length) * 100);
                  
                  return (
                    <Box key={`status-${status}-${index}`} sx={{ mb: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box 
                            component="span" 
                            sx={{ 
                              display: 'inline-block', 
                              width: 12, 
                              height: 12, 
                              borderRadius: '50%', 
                              bgcolor: statusColor,
                              mr: 1
                            }} 
                          />
                          {formattedStatus}
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {statusData[status]} ({percentage}%)
                        </Typography>
                      </Box>
                      <LinearProgress 
                        variant="determinate" 
                        value={percentage} 
                        sx={{ 
                          height: 6, 
                          borderRadius: 3,
                          bgcolor: 'rgba(0,0,0,0.05)',
                          '& .MuiLinearProgress-bar': {
                            bgcolor: statusColor
                          }
                        }} 
                      />
                    </Box>
                  );
                })
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 4 }}>
                  {t('TIDAK ADA DATA STATUS YANG TERSedia')}
                </Typography>
              );
              })()}
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ProjectStatusDistribution;
